import styled from 'styled-components';

export const StyledMintButton = styled.div`
  background: transparent;
  height: 100%;
  width: 100%;
  cursor: pointer;
  position: relative;

  &:hover {
    .mint-button-corner {
      border: ${({theme, $disabled, $selected}) => $disabled === true ? 'none' : `solid ${theme.buttonFrameWidth} ${$selected ? theme.selection : 'white'}`};
    }

    .mint-button-corner-l {
      border-right: none;
    }

    .mint-button-corner-r {
      border-left: none;
    }
  }

  .mint-button-disabled {
    font-family: "BebasNeue";
    font-size: 1em;
    font-weight: 700;
    height: 100%;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
  }

  .mint-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 2px rgba(0, 0, 0, .16);
    cursor: pointer;
    color: black;
    background: ${({ theme, $color }) => $color == null ? theme.buttonLightGreen : $color};
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 1em;
    font-weight: 700;
    padding: 3px 10px;
    height: 100%;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1;
    transition: linear 0.2s;

    @media (max-width: ${({ theme }) => theme.mobile}) {
      border-width: 1px;
      font-weight: 400;
      padding: 8px;
    }

    &:hover {
      padding: 3px ${({ $animated }) => $animated ? '20px' : '20px'};
    }
  }

  .mint-button-corner {
    position: absolute;
    border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'transparent'};
    top: 0;
    bottom: 0;
    width: 8px
  }

  .mint-button-corner-l {
    border-right: none;
    left: 0;
  }

  .mint-button-corner-r {
    border-left: none;
    right: 0;
  }
`;
